import { createContext, useContext } from 'react';
import type { InputToken } from '../utils';

type InputTokenInteractionContextValue = {
  onTokenClick?: (token: InputToken) => void;
};

export const InputTokenInteractionContext =
  createContext<InputTokenInteractionContextValue>({});

export function useInputTokenInteraction() {
  return useContext(InputTokenInteractionContext);
}
